import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const labelMap: Record<string, string> = {
  category: '服务分类',
  article: '文章详情',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  if (pathParts.length === 0) return null;

  const crumbs = [{ label: '首页', path: '/' }];

  let currentPath = '';
  for (const part of pathParts) {
    currentPath += `/${part}`;
    let label = '';

    if (part === 'category') {
      label = labelMap.category;
    } else if (part === 'article') {
      label = labelMap.article;
    } else if (part === 'about') {
      label = labelMap.about;
    } else {
      const cat = categories.find((c) => c.slug === part);
      if (cat) {
        label = cat.name;
        currentPath = `/category/${part}`;
      } else {
        label = decodeURIComponent(part);
      }
    }

    crumbs.push({ label, path: currentPath });
  }

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': `https://xingshizixun.com${crumb.path}`,
        name: crumb.label,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <nav aria-label="面包屑导航" className="pt-20 pb-4 px-4 md:px-6 max-w-7xl mx-auto">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {crumbs.map((crumb, index) => (
            <li key={crumb.path} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {index === crumbs.length - 1 ? (
                <span className="text-foreground-600">{crumb.label}</span>
              ) : (
                <Link
                  to={crumb.path}
                  className="text-foreground-400 hover:text-primary-600 transition-colors duration-200"
                >
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}